module.exports = __webpack_public_path__ + "img/3.8cd85a86.png";